import { render, staticRenderFns } from "./basecreditosactivos.vue?vue&type=template&id=5e650ea6"
import script from "./basecreditosactivos.vue?vue&type=script&lang=js"
export * from "./basecreditosactivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports